import * as list from "../list";
import { option as O, either as E } from "fp-ts";
import * as M from "../managed";
import * as T from "../effect";
export function queueUtils() {
    const ops = list.empty();
    const hasCB = {};
    function next(o) {
        if (hasCB.cb) {
            const cb = hasCB.cb;
            hasCB.cb = undefined;
            cb(o);
        }
        else {
            // TODO: figure out how to trigger if even possible
            /* istanbul ignore next */
            list.push(ops, o);
        }
    }
    return { ops, hasCB, next };
}
export function runFromQueue(op, callback) {
    switch (op._tag) {
        case "error":
            callback(E.left(op.e));
            // this will never be called
            /* istanbul ignore next */
            // tslint:disable-next-line: no-empty
            return () => { };
        case "complete":
            callback(E.right(O.none));
            // tslint:disable-next-line: no-empty
            return () => { };
        case "offer":
            callback(E.right(O.some(op.a)));
            // tslint:disable-next-line: no-empty
            return () => { };
    }
}
export function emitter(ops, hasCB) {
    return M.pure(T.async((callback) => {
        const op = list.popUnsafe(ops);
        if (op !== null) {
            runFromQueue(op, callback);
        }
        else {
            hasCB.cb = (o) => {
                // TODO: figure out how to trigger if even possible, triggered by line 22
                /* istanbul ignore if */
                if (list.isNotEmpty(ops)) {
                    list.push(ops, o);
                    const op = list.popUnsafe(ops);
                    if (op !== null) {
                        runFromQueue(op, callback)();
                    }
                }
                else {
                    runFromQueue(o, callback)();
                }
            };
        }
        /* istanbul ignore next */
        return (cb) => {
            cb();
        };
    }));
}
